import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import List from '../components/productlisting/List';
import CategoriesFilter from '../components/productlisting/CategoriesFilter';
import ContactUs from '../sections/home/Contactus';
import HomeSearch from '../components/home/HomeSearch';
import axios from 'axios';
import { Icon } from '@iconify/react/dist/iconify.js';
import { getCookie } from '../components/auth/login/GetCookie';

function ProductListing({isAuthenticated}) {
  const navigate = useNavigate()
    const location = useLocation();
    const [currentPage, setCurrentPage] = useState(1);
    const [searchResults, setSearchResults] = useState(location.state?.results || [])
    const [isLoading, setIsLoading] = useState(null);
    const [totalPages, setTotalPages] = useState(0)
    console.log("Prams as sson as we enter the list :",location.state?.params);
    const [params, setParams] = useState(location.state?.params || {})
      useEffect(() => {
        console.log("Prams: in product listing : ",params);
        fetchSeachData();
        
      }, [location,currentPage]);


      const handleNext = () => {
        if (currentPage < totalPages) setCurrentPage((prev) => prev + 1);
    };
    const handlePrev = () => {
        if (currentPage > 1) setCurrentPage((prev) => prev - 1);
    };
      const fetchSeachData = async () =>{
    const newParams = {
      ...params, // Spread existing params
      pageNumber: currentPage - 1,
      pageSize: 20,
    };
        setIsLoading(true)
        // const token = localStorage.getItem("token");
        const token = getCookie("token");
        
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/api/v1/user/products/search`,
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
            params:newParams, // Passing params directly
          }
        );
        setSearchResults(response.data.content);
        setTotalPages(response.data.totalPages) 
        setIsLoading(false)
      }
      const setFilterParamsForSeach = (qParams) =>{
        setParams(qParams)
      }
    return (
        <div className='mt-5'>
            <HomeSearch qparams={params} setSearchResults={setSearchResults} setParams={setParams} isAuthenticated={isAuthenticated}/>
            <div className='mx-lg-5 mx-3 mt-2'>
                
                <div className='d-flex flex-wrap py-5 '>
                    <div className='col-lg-2 px-lg-3 px-2 col-xs-2 '>
                        <CategoriesFilter params ={params} setSearchResults={setSearchResults} setIsLoading={setIsLoading} />
                    </div>
                    <div className='col-lg-10 px-lg-3 px-2 col-xs-12'>
                        {/* Pass searchResults to the List component */}
                        <List results={searchResults} isLoading={isLoading} />
                        <div className='d-flex justify-content-between ms-auto'>
                            <div> </div>
                        <div className="d-flex justify-content-between align-items-center mt-3">
                            <span className='me-2'>{currentPage} of {totalPages}</span>
                            <button className="btn" onClick={handlePrev} disabled={currentPage === 1}>
                                <Icon icon="grommet-icons:previous" />
                            </button>
                            <button className="btn ms-2" onClick={handleNext} disabled={currentPage === totalPages}>
                                <Icon icon="grommet-icons:next" />
                            </button>
                        </div>
                    </div>
                    </div>
                </div>
            </div>
            <ContactUs />
        </div>
    );
}

export default ProductListing;
